import { useState } from "react"

export default function History(props) {
    const opciones = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const fechaObjeto = new Date(props.Date.replace(/-/g, '\/'));
    
    return (
                <tr>
                    <td >{new Intl.DateTimeFormat('es-MX', opciones).format(fechaObjeto)}</td>
                    <td >{props.Title}</td>
                    <td >{props.Desc}</td>
                </tr>


            
        
    )
}
